// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1l__4","modalForm":"UpgradeEpcsModal_modalForm__26-bX","modalFooter":"UpgradeEpcsModal_modalFooter__1EivH"};